import api from '@/api';
import i18n from '@/i18n';
import utilities from '@/helpers/utilities';

const state = {
    contracts: [],
    contract: {},
};

const mutations = {
    setContract(state, contract) {
        state.contract = contract;
    },
    setContracts(state, contracts) {
        state.contracts = contracts;
    },
};

const actions = {
    async fetchContract({ commit }, id) {
        const response = await api.contracts.fetch(id);
        commit('setContract', response.data);
    },
    async loadContracts({ commit }) {
        const response = await api.contracts.list();
        commit('setContracts', response.data);
    },
    async removeContract({ dispatch }, form) {
        await api.contracts.remove(form.id);
        await dispatch('loadContracts');

        dispatch('showSuccess', i18n.t('message.success.contractRemoved'));
    },
    async saveContract({ dispatch }, form) {
        const response = await api.contracts.save(form);
        await dispatch('fetchContract', response.data.id);
    },
    async saveOrUpdateContract({ dispatch }, form) {
        if (utilities.isEmptyOrZero(form.id)) {
            await dispatch('saveContract', form);
        } else {
            await dispatch('updateContract', form);
        }

        await dispatch('loadContracts');
        await dispatch('loadContractItems');
        dispatch('showSuccess', i18n.t('message.success.saved'));
    },
    async updateContract({ dispatch }, form) {
        await api.contracts.update(form.id, form);

        await dispatch('fetchContract', form.id);
    },
};

const getters = {
    contract(state) {
        return state.contract;
    },
    contracts(state) {
        const contracts = state.contracts || [];
        return contracts.sort((a, b) => utilities.stringCompare(a.number, b.number));
    },
    contractsValueText(_, getters) {
        return getters.contracts.map(({ id, number, description, isActive, validityTerm }) => ({
            value: id,
            text: `${number} - ${utilities.toDate(validityTerm.finish)} - ${description}`,
            isActive,
        }));
    },
    contractsDictionary(_, getters) {
        return getters.contracts.reduce((map, obj) => {
            map[obj.id] = obj;
            return map;
        }, {});
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};


// WEBPACK FOOTER //
// ./src/store/modules/contracts.js